var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_365_4621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1837 27.349C14.345 27.1865 14.5667 27.0918 14.8018 27.0918H36.1258C36.5154 27.0918 36.7102 27.5655 36.4348 27.843L32.2224 32.0861C32.0612 32.2485 31.8395 32.3432 31.6043 32.3432H10.2804C9.89071 32.3432 9.69588 31.8695 9.97133 31.5921L14.1837 27.349Z",
    fill: "url(#paint0_linear_365_4621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1838 11.5072C14.3518 11.3447 14.5735 11.25 14.8019 11.25H36.1258C36.5155 11.25 36.7103 11.7237 36.4349 12.0012L32.2225 16.2443C32.0613 16.4067 31.8395 16.5014 31.6044 16.5014H10.2805C9.89079 16.5014 9.69596 16.0277 9.97141 15.7503L14.1838 11.5072Z",
    fill: "url(#paint1_linear_365_4621)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2224 19.3773C32.0612 19.2149 31.8395 19.1201 31.6043 19.1201H10.2804C9.89071 19.1201 9.69588 19.5938 9.97133 19.8713L14.1837 24.1144C14.345 24.2768 14.5667 24.3716 14.8018 24.3716H36.1258C36.5154 24.3716 36.7102 23.8978 36.4348 23.6204L32.2224 19.3773Z",
    fill: "url(#paint2_linear_365_4621)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_4621",
    x1: 34.0887,
    y1: 8.71477,
    x2: 19.1616,
    y2: 37.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_365_4621",
    x1: 27.6358,
    y1: 5.32173,
    x2: 12.7087,
    y2: 33.7062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_365_4621",
    x1: 30.8417,
    y1: 7.00742,
    x2: 15.9145,
    y2: 35.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_365_4621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7188,
    height: 21.0938,
    fill: "white",
    transform: "translate(9.84375 11.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.486012684b92142f5f773253baad7652.svg";
export { ForwardRef as ReactComponent };